export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('from_label_custCode') || '下单客户',
    field: 'custCode',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/customerSelect',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_endcustCode') || '终端客户',
    field: 'endCustCode',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/customerSelect',
        filterable: true,
        clearable: true,
      },
    },
  },
]
